/* eslint-disable import/first */
import React, { Suspense, useEffect, useRef, useState } from "react";
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import logo2 from "./Assets/logo2.svg";
// Hooks, not components — React.lazy() only works for things rendered as
// JSX (it returns a lazy-loader object, not a callable function). Calling a
// lazy-wrapped hook directly throws "X is not a function" on every render.
import useAppRedirect from "./AppRedirectModal/useAppRedirect.js";
import useUserLocation from "./LocationPopUp/useUserLocation.js";

const ArtistCard = React.lazy(() => import("./Artist Component/Card/Artist.js"));
const MyBookingHistory = React.lazy(() => import("./BookingHistory/MyBookingHistory.js"));
const CarnivalPassPayment = React.lazy(() => import("./Carnival/CarnivalPassPayment.js"));
const CarnivalPassPaymentStatus = React.lazy(() => import("./Carnival/CarnivalPassPaymentStatus.js"));
const CarnivalPassRefund = React.lazy(() => import("./Carnival/CarnivalPassRefund.js"));
const CarnivalPassRefundStatus = React.lazy(() => import("./Carnival/CarnivalPassRefundStatus.js"));
const Summerypage = React.lazy(() => import("./Carnival/Summerypage.js"));
const BookNowBookATable = React.lazy(() => import("./Carnival/bookatablenow.js"));
const ClubDetails = React.lazy(() => import("./Club About Us/Club_full_Details"));
const ClubAgreement = React.lazy(() => import("./Club Agreement/Agreement"));
const ArtistAgreement = React.lazy(() => import("./Club Agreement/Artist-agreement"));
const Cancellationpolicy = React.lazy(() => import("./Club Agreement/Cancellationpolicy"));
const Privacypolicy = React.lazy(() => import("./Club Agreement/Privacypolicy"));
const RefundPolicy = React.lazy(() => import("./Club Agreement/Refundpolicy"));
const Termscondition = React.lazy(() => import("./Club Agreement/Termsandcondition"));
const ClubDetail = React.lazy(() => import("./Club Detail Component/index.js"));
const Clubpage = React.lazy(() => import("./Club-page/Clubpage"));
const Asanartist = React.lazy(() => import("./Footer section page/Asanartist"));
const Services = React.lazy(() => import("./Footer section page/Services"));
const BookanArtist = React.lazy(() => import("./Footer section page/bookanartist"));
const ContactUs = React.lazy(() => import("./Footer section page/contactus"));
const PartnerwithUs = React.lazy(() => import("./Footer section page/partnerwithus"));
const Happeningparty = React.lazy(() => import("./Happening Party page/Happeningparty"));
const HappeningViewButton = React.lazy(() => import("./Happening-paty-view-button/Happening-view"));
const CommingSoon = React.lazy(() => import("./Happening-paty-view-button/comming-soon"));
const MusicViewButton = React.lazy(() => import("./Happening-paty-view-button/music-zoner-view"));
const Fireworks = React.lazy(() => import("./Homepage/Newyearpagelight"));
const HoliFailed = React.lazy(() => import("./New--Thankew--page/Holi-Failed-page"));
const NewThankewPage = React.lazy(() => import("./New--Thankew--page/NewThanke--page"));
const OurArtist = React.lazy(() => import("./Ourartist/OurArtist"));
const Paymentpage = React.lazy(() => import("./Paymentpage"));
const Successpage = React.lazy(() => import("./Successpage"));
const ThankewPage = React.lazy(() => import("./Thankewpage/Thankew-page"));
const BlogDetails = React.lazy(() => import("./blog-page/Blogdetails.js"));
const Blog = React.lazy(() => import("./blog-page/blog"));
const RegistrationLoginForm = React.lazy(() => import("./club-registration-page/registration"));

const FavorateHangoutThumbnail = React.lazy(() => import("./favorate-hangout-page/Favorate--hangout--thumbnail"));
const GroupBookingViewall = React.lazy(() => import("./favorate-hangout-page/GroupBookingViewall"));
const TableBookingViewall = React.lazy(() => import("./favorate-hangout-page/TableBooking--view--all"));
const MyBooking = React.lazy(() => import("./hamburger--content/My--Booking"));
const MyNotification = React.lazy(() => import("./hamburger--content/My--Notification"));
const MyProfile = React.lazy(() => import("./hamburger--content/My--Profile"));
const MyFavorite = React.lazy(() => import("./hamburger--content/My--favorate"));
const SearchResult = React.lazy(() => import("./searchResult"));
const GroupBooking = React.lazy(() => import("./Components/Table_booking/PackageLeadForm.js"));
const HomeV2 = React.lazy(() => import("./v2/home/index.js"));
const PackageLeadSubmitted = React.lazy(() => import("./Components/Table_booking/package-lead-submitted.js"));
const RegistrationLoginFormSubmitted = React.lazy(() => import("./club-registration-page/resgistration-submitted.js"));
const EvenetListingPage = React.lazy(() => import("./event-view-all-page/EvenetListingPage.js"));
const PartyPackageListingPage = React.lazy(() => import("./My--Bidding--design/PartyPackageListingPage.js"));
const TableBookingForm = React.lazy(() => import("./Components/Table_booking/TableBookingForm.js"));
const FeedPage = React.lazy(() => import("./Feed Page/FeedPage.js"));
const FeedPageUno = React.lazy(() => import("./Feed Page/FeedPageUno.js"));

const PaymentDonePage = React.lazy(() => import("./Payment-successful/PaymentDonePage.js"));
const PaymentConfirmPage = React.lazy(() => import("./Payment-successful/PaymentConfirmPage.js"));
const AddMenuPage = React.lazy(() => import("./MenuPage/AddMenuPage.js"));
const Home = React.lazy(() => import("./CRP/pages/Home.jsx"));
const VenuesListingPage = React.lazy(() => import("./My--Bidding--design/VenuesListingPage.js"));
const VenueClubDetailsPage = React.lazy(() => import("./Club-aboutus/VenueClubDetailsPage.js"));
const PartyPackageDetailPage = React.lazy(() => import("./Club-aboutus/PartyPackageDetailPage.js"));
const VenueDetailSeoPage = React.lazy(() =>
  import("./Discover-Profile/VenuePackageDetailPage.jsx").then((m) => ({ default: m.VenueDetailSeoPage })));
const PackageDetailSeoPage = React.lazy(() =>
  import("./Discover-Profile/VenuePackageDetailPage.jsx").then((m) => ({ default: m.PackageDetailSeoPage })));

const MyBookingPage = React.lazy(() => import("./BookingHistory/MyBookingPage.js"));

const EventDetailPage = React.lazy(() => import("./event-view-all-page/EventDetailPage.js"));
const TableLeadSubmitted = React.lazy(() => import("./Components/Table_booking/TableLeadSubmitted.js"));
const EventBooking = React.lazy(() => import("./event-view-all-page/EventBooking.js"));
const MetaHead = React.lazy(() => import("./MetaHead.js"));
const PartnerWithUs = React.lazy(() => import("./PackagePrice/PartnerWithUs.js"));
const OrderSummary = React.lazy(() => import("./My--Bidding--design/OrderSummery.js"));
const Checkout = React.lazy(() => import("./My--Bidding--design/Checkout.js"));
const ContactUsThankYou = React.lazy(() => import("./Footer section page/ContactUsThankYou.js"));
import { askWittyAuthLandingPath, stashAskWittyAuthIntent } from "./auth/askWittyAuthIntent";
import { readCustomerAuthSnapshot } from "./auth/useCustomerAuth";
const MyFavClub = React.lazy(() => import("./Favorate Component/MyFavClub.js"));
const EventThankYouPage = React.lazy(() => import("./event-view-all-page/EventThankYouPage.js"));
const ArtistsListingPage = React.lazy(() => import("./Artist Component/Card/ArtistsListingPage.js"));
const ArtistHireDetailPage = React.lazy(() => import("./ArtistHire/ArtistHireDetailPage.js"));
const ArtistQuoteFormPage = React.lazy(() => import("./ArtistHire/ArtistQuoteFormPage.js"));
const ArtistQuotesPage = React.lazy(() => import("./ArtistHire/ArtistQuotesPage.js"));
const ArtistBookingCheckoutPage = React.lazy(() => import("./ArtistHire/ArtistBookingCheckoutPage.js"));
const ArtistBookingThankYouPage = React.lazy(() => import("./ArtistHire/ArtistBookingThankYouPage.js"));
const ArtistOpportunityPage = React.lazy(() => import("./ArtistOpportunity/ArtistOpportunityPage.js"));
// ponytail: moved CSS import to lazy load in Routerpage component to defer blocking render
const AppContinuationLanding = React.lazy(() => import("./AppRedirectModal/AppContinuationLanding.js"));
import { API_BASE_URL, setClubFavourited } from "./utils.js";
const MyBookingDetail = React.lazy(() => import("./BookingHistory/MyBookingDetail.js"));
const InviteFlowDemo = React.lazy(() => import("./BookingHistory/InviteFlowDemo.js"));
const GigExecutionPage = React.lazy(() => import("./GigExecution/GigExecutionPage.js"));
const DiscoverMeetReview = React.lazy(() => import("./BookingHistory/DiscoverMeetReview.js"));
const GuestMeetReview = React.lazy(() => import("./BookingHistory/GuestMeetReview.js"));
const FloatingHelpWidget = React.lazy(() => import("./Components/FloatingHelpWidget/FloatingHelpWidget"));
const AskWittySignoutFeedback = React.lazy(() => import("./Discover-Profile/AskWittySignoutFeedback.jsx"));
const AskWittyPage = React.lazy(() => import("./Discover-Profile/AskWittyPage.js"));
const DiscoverPrivateRoomPage = React.lazy(() => import("./Discover-Profile/DiscoverPrivateRoom.jsx"));
import LegacyAskWittyRedirect from "./Discover-Profile/LegacyAskWittyRedirect";
const AddGuestList = React.lazy(() => import("./MenuPage/custom-comp/AddGuestList.js"));
import { requestPermission, listenForMessages } from "./firebase/push.js";
const AboutusPageNew = React.lazy(() => import("./Footer section page/AboutusPageNew.js"));
const ScrollToTop = React.lazy(() => import("./ScrollToTop.js"));
const PixelManager = React.lazy(() => import("./Marketing/PixelManager.js"));
const PackageListingPage = React.lazy(() => import("./My--Bidding--design/PackageListingPage.js"));
const BidListingPageNew = React.lazy(() => import("./My--Bidding--design/BidListingPageNew.js"));
const CateringBidListing = React.lazy(() => import("./My--Bidding--design/CateringBidLishting.js"));

const CateringBidDetailPage = React.lazy(() => import("./Club-aboutus/CateringDetailPage.js"));

const PageNotFound = React.lazy(() => import("./PageNotFound.js"));
const HomeHeaderSidebar = React.lazy(() => import("./HomeHeaderSidebar.js"));
const ClubReviewPage = React.lazy(() => import("./BookingHistory/customComp/ClubReviewPage.js"));
const ClubReviewThankYou = React.lazy(() => import("./BookingHistory/customComp/ClubReviewThankYou.js"));
const VenueClubReview = React.lazy(() => import("./Club-aboutus/custom-comp/VenueClubReview.js"));
const PartywittyPay = React.lazy(() => import("./partywittyPay/PartywittyPay.js"));
const PartywittyCheckout = React.lazy(() => import("./partywittyPay/PartywittyCheckout.js"));
const VenueMenuPage = React.lazy(() => import("./VenueMenuPage/VenueMenuPage.js"));
const TableBidCard = React.lazy(() => import("./My--Bidding--design/comp/TableBidCard.js"));
const ProfileV2 = React.lazy(() => import("./Components/Artist/ProfileV2.js"));
const ProfileArtistPage = React.lazy(() => import("./UserProfile/ProfileArtistPage.js"));
const ProfilePersonalDetailsPage = React.lazy(() => import("./UserProfile/ProfilePersonalDetailsPage.js"));
const ProfileSelfViewPage = React.lazy(() => import("./UserProfile/ProfileSelfViewPage.js"));
const ProfileCompletePage = React.lazy(() => import("./UserProfile/ProfileCompletePage.js"));
const MateRequestsPage = React.lazy(() => import("./UserProfile/MateRequestsPage.js"));
const NewMyPlan = React.lazy(() => import("./Components/Table_booking/BookingForm/NewMyPlan.js"));
const GoToTopButton = React.lazy(() => import("./GoToTopButton.js"));
const CateringListingPage = React.lazy(() => import("./catering/CateringListingPage.js"));
const CateringDetailPage = React.lazy(() => import("./catering/CateringDetailPage.js"));
const PartywittyPayThankyou = React.lazy(() => import("./partywittyPay/PartywittyPayThankyou.js"));
const WalletPage = React.lazy(() => import("./UserWallet/WalletPage.js"));
const Transaction = React.lazy(() => import("./UserWallet/Transaction.js"));
const ChatSectionUnique = React.lazy(() => import("./messageSection/ChatSectionUnique.js"));
const CareersPage = React.lazy(() => import("./Careers/CareersPage.js"));
const RoleProtectedRoute = React.lazy(() => import("./RoleProtectedRoute.js"));
const DashboardRouter = React.lazy(() => import("./DashboardRouter.js"));
const RefundPage = React.lazy(() => import("./RefundOptions/RefundPage.js"));
const PartnerAsAnCaterer = React.lazy(() => import("./partner-with-us-onbording/PartnerAsAnCaterer.js"));
const PAACOnbordingForm = React.lazy(() => import("./partner-with-us-onbording/components/PAACOnbordingForm.js"));
const CrownMembershipForm = React.lazy(() => import("./CRP/crown/CrownMembershipForm.js"));
const EventOrgOnboardingPage = React.lazy(() => import("./EventOrgnizer/EventOrgOnboardingPage.js"));
const EventOrgOnboardingForm = React.lazy(() => import("./EventOrgnizer/EventOrgOnboardingForm.js"));
const FeedDemo = React.lazy(() => import("./Feed Page/custom-comp/FeedDemo.js"));
const CarnivalsListing = React.lazy(() => import("./CarnivalsListing/CarnivalsListing.js"));
const CarnivalDetailPage = React.lazy(() => import("./CarnivalsListing/CarnivalDetailPage.js"));
const ArtistOnboardingForm = React.lazy(() => import("./Artist Component/ArtistOnboardingForm.js"));
const ArtistOnboardingFormThankYou = React.lazy(() => import("./Artist Component/ArtistOnboardingFormThankYou.js"));
const CarnivalBooking = React.lazy(() => import("./CarnivalsListing/CarnivalBooking.js"));
const CarnivalThankYou = React.lazy(() => import("./CarnivalsListing/CarnivalThankYou.js"));
const VenueLandingPage = React.lazy(() => import("./partner-with-us-onbording/VenueLandingPage.js"));
const PartnerAsAnArtist = React.lazy(() => import("./partner-with-us-onbording/PartnerAsAnArtist.js"));
const Influencer = React.lazy(() => import("./partner-with-us-onbording/Influencer.js"));
const EventOrganizer = React.lazy(() => import("./partner-with-us-onbording/EventOrganizer.js"));
const PartnerEnquiryThankYou = React.lazy(() => import("./partner-with-us-onbording/PartnerEnquiryThankYou.js"));

const Compare = React.lazy(() => import("./My--Bidding--design/PackageComparisonPage.js"));
const CRPProfile = React.lazy(() => import("./CRP/CRPProfile.js"));
const Components = React.lazy(() => import("../src/Componets.js"));
const Buttons = React.lazy(() => import("./Components/Buttons.js"));
const Icons = React.lazy(() => import("./Components/Icon.js"));
const Fonts = React.lazy(() => import("./Components/Fonts.js"));
const Cards = React.lazy(() => import("./Components/Cards.js"));
const Chat = React.lazy(() => import("./Chat/Chat.js"));
const CarrotsTransaction = React.lazy(() => import("./UserWallet/CarrotsTransaction.js"));
const TulipsTransaction = React.lazy(() => import("./UserWallet/TulipsTransaction.js"));
const VoucherTransaction = React.lazy(() => import("./UserWallet/VoucherTransaction.js"));
const MultiplebookingPay = React.lazy(() => import("../src/Club-aboutus/MultiplebookingPay.js"));
const DiscoverProfile = React.lazy(() => import("../src/Discover-Profile/DiscoverProfile.js"));
const PopupQueueManager = React.lazy(() => import("./Components/PopupQueueManager"));
const Discover = React.lazy(() => import("../src/Discover-Profile/Discover.js"));
const ReferralLanding = React.lazy(() => import("../src/Discover-Profile/ReferralLanding.jsx"));
const DiscoverProfileDetail = React.lazy(() => import("../src/Discover-Profile/DiscoverProfileDetail.js"));
const UserInterestRecord = React.lazy(() => import("../src/Navbar/UserInterestRecord.js"));
const EventsListing = React.lazy(() => import("../src/Discover-Profile/EventsListing.js"));
const DrinkLishting = React.lazy(() => import("../src/Discover-Profile/DrinkLishting.js"));
const DiscoverOrderSummery = React.lazy(() => import("../src/Discover-Profile/DiscoverOrderSummery.js"));
const ProfileVerificationFlow = React.lazy(() => import("../src/Discover-Profile/ProfileVerificationFlow.js"));
const DiscoverSwipeHistory = React.lazy(() => import("../src/Discover-Profile/DiscoverSwipeHistory.js"));
const EventInvitation = React.lazy(() => import("../src/Discover-Profile/EventInvitation.js"));
const InviteEventPicker = React.lazy(() => import("../src/Discover-Profile/InviteEventPicker.jsx"));

import {
  fetchSocialNotifications,
  fetchMateOutNotifications,
  markSocialNotificationRead,
  markAllSocialNotificationsRead,
  getPendingFollowRequests,
} from "./api/socialApi.js";
import {
  customerApiClient,
  CUSTOMER_SESSION_EXPIRED_EVENT,
} from "./api/customerHttpClient.js";
import { fetchFlags } from "./lib/appFlags.js";
const DeepLinkHandler = React.lazy(() => import("./PartyReadyScore/DeepLinkHandler.js"));
const ScorePage = React.lazy(() => import("./PartyReadyScore/ScorePage.js"));
const BadgeShowcase = React.lazy(() => import("./PartyReadyScore/BadgeShowcase.js"));
const WeeklyLeaderboard = React.lazy(() => import("./PartyReadyScore/WeeklyLeaderboard.js"));
const ReferralDashboard = React.lazy(() => import("./PartyReadyScore/ReferralDashboard.js"));
const VerificationSuccess = React.lazy(() => import("./WittyPrezo/VerificationSuccess.js"));
const ScoreLoading = React.lazy(() => import("./WittyPrezo/ScoreLoading.js"));
const WittyPrezoScoreCard = React.lazy(() => import("./WittyPrezo/WittyPrezoScoreCard.js"));
const FeedPostPreview = React.lazy(() => import("./WittyPrezo/FeedPostPreview.js"));
const StoryExport = React.lazy(() => import("./WittyPrezo/StoryExport.js"));
const WittyPrezoBreakdown = React.lazy(() => import("./WittyPrezo/WittyPrezoBreakdown.js"));
const WittyCueIntro = React.lazy(() => import("./EventChat/WittyCueIntro.js"));
const EventChatThread = React.lazy(() => import("./EventChat/EventChatThread.js"));
const PolicyListPage = React.lazy(() => import("./Policy/PolicyListPage.js"));
const PolicyDetailPage = React.lazy(() => import("./Policy/PolicyDetailPage.js"));
const GuestLoginPrompt = React.lazy(() => import("./Discover-Profile/GuestLoginPrompt.js"));
const iziToast = React.lazy(() => import("izitoast"));
const GoTonight = React.lazy(() => import("./Discover-Profile/GoTonight.js"));
const DiscoverReadyPage = React.lazy(() => import("./discover-ready/DiscoverReadyPage.js"));
const FoundingPage = React.lazy(() => import("./founding/FoundingPage.js"));
import {
  buildProfileGapNotifications,
  getNotificationKey,
  isNotificationUnread,
  normalizeNotificationList,
  normalizeNotificationPayload,
} from "./notifications/customerNotificationUtils.js";

// Dev-only Discover coverage dashboard (/dev/coverage). The require() sits inside
// a NODE_ENV guard so webpack drops the component AND its seed registry from
// production bundles entirely — it never ships to prod, not merely hidden.
let CoverageTracker = null;
if (process.env.NODE_ENV !== "production") {
  // eslint-disable-next-line global-require
  CoverageTracker = require("./dev/coverage/CoverageTracker").default;
}

// Dev-only Platform Rules registry (/dev/rules) — same guard as CoverageTracker.
let PlatformRulesViewer = null;
if (process.env.NODE_ENV !== "production") {
  // eslint-disable-next-line global-require
  PlatformRulesViewer = require("./dev/rules/PlatformRulesViewer").default;
}

// Arsenal is available in local development by default. A dedicated internal
// dev.partywitty.com build may opt in explicitly. Lazy imports keep the large
// replica catalogue out of the normal customer bundle.
const ARSENAL_BUILD_ENABLED =
  process.env.NODE_ENV !== "production" ||
  process.env.REACT_APP_ASKWITTY_ARSENAL_ENABLED === "true";
const VpnArsenalRoute = ARSENAL_BUILD_ENABLED
  ? React.lazy(() => import("./Discover-Profile/VpnArsenalRoute.jsx"))
  : null;
const WittyCardArsenal = ARSENAL_BUILD_ENABLED
  ? React.lazy(() => import("./Discover-Profile/WittyCardArsenal.jsx"))
  : null;

function NavbarConditional({
  userData,
  url,
  logo2,
  notif,
  setCreateLeadModel,
  onMarkNotificationRead,
  onMarkAllNotificationsRead,
  onFollowRequestHandled,
  notificationLoading,
  notificationError,
  onRetryNotifications,
}) {
  const location = useLocation();

  const hideNavbarRoutes = [
    "/package-booking/",
    "/login",
    "/signup",
    "/partywitty-pay",
    "/v/",
    "/qr/",
    "/m/",
    "/result",
    "/discover-profile-detail",
    "/profile/self",
    "/profile/complete",
    "/discover-order-summery",
    "/discover-meet-review",
    "/discover-guest-review",
    "/demo/invite-flow",
    "/career",
    "/founding",
    "/artist/opportunity/",
    // "/success",
    // "/nextPage",
    // "/summerypage",
  ];
  const hideNavbarExactRoutes = [
    "/askwitty",
    "/ask-witty",
    "/discover",
    "/discover-verification",
    "/drink-listing",
    "/drink-lishting",
  ];

  const shouldShowNavbar = () => {
    const isDiscoverInvite =
      location.pathname === "/discover" &&
      new URLSearchParams(location.search).get("mode") === "invite";

    if (isDiscoverInvite) {
      return true;
    }

    // MateOut invite detail uses the discover header instead of the navbar
    const isMateOutDetail =
      location.pathname.startsWith("/my-bookings-details") &&
      new URLSearchParams(location.search).get("booking_type") === "mateout";

    if (isMateOutDetail) {
      return false;
    }

    return (
      !hideNavbarExactRoutes.includes(location.pathname) &&
      !hideNavbarRoutes.some((route) => location.pathname.startsWith(route))
    );
  };

  return shouldShowNavbar() ? (
    <HomeHeaderSidebar
      userData={userData}
      url={url}
      logo2={logo2}
      notif={notif}
      setCreateLeadModel={setCreateLeadModel}
      onMarkNotificationRead={onMarkNotificationRead}
      onMarkAllNotificationsRead={onMarkAllNotificationsRead}
      onFollowRequestHandled={onFollowRequestHandled}
      notificationLoading={notificationLoading}
      notificationError={notificationError}
      onRetryNotifications={onRetryNotifications}
    />
  ) : null;
}

function getSafeLoginRedirect(value) {
  const redirect = String(value || "").trim();
  if (!redirect || !redirect.startsWith("/") || redirect.startsWith("//")) {
    return "/";
  }
  if (/^\/(?:login|signup)(?:\/|$)/i.test(redirect)) return "/";
  return redirect;
}

function SessionExpiredLoginPrompt() {
  const navigate = useNavigate();
  const location = useLocation();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const handleSessionExpired = () => setShow(true);
    window.addEventListener(
      CUSTOMER_SESSION_EXPIRED_EVENT,
      handleSessionExpired,
    );
    return () => {
      window.removeEventListener(
        CUSTOMER_SESSION_EXPIRED_EVENT,
        handleSessionExpired,
      );
    };
  }, []);

  const handleLogin = () => {
    setShow(false);
    const redirect = getSafeLoginRedirect(
      `${location.pathname}${location.search}${location.hash}`,
    );
    navigate(`/login?redirect=${encodeURIComponent(redirect)}`, {
      state: { from: redirect },
    });
  };

  return (
    <GuestLoginPrompt
      show={show}
      onClose={() => setShow(false)}
      onLogin={handleLogin}
      title="Your session has expired"
      description="Please log in again to continue where you left off."
      loginLabel="Log in"
      secondaryLabel="Not now"
    />
  );
}

function LoginRoute({ userData, intentReason = "login_route" }) {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  let rememberedPath = "";
  try { rememberedPath = window.sessionStorage.getItem("pw_last_classic_path_v1") || ""; } catch {}
  const redirect = getSafeLoginRedirect(
    params.get("redirect") || location.state?.from || rememberedPath,
  );

  if (userData) return <Navigate to={redirect} replace />;

  // Ask Witty is the only customer login/signup surface. Callers that still
  // navigate to /login are bounced back to their intended page; the Ask Witty
  // sidecar or full-page chat consumes this pending intent and opens its auth
  // card there. The legacy LoginPage is not rendered by this route.
  //
  // The sidecar is desktop-only, so below that breakpoint the guest goes to the
  // full-page chat instead — bouncing them back to a page with no auth host
  // would strand the intent and leave them unable to log in at all.
  stashAskWittyAuthIntent({ returnTo: redirect, reason: intentReason });
  return <Navigate to={askWittyAuthLandingPath(redirect)} replace />;
}

// Must stay at module scope: defined inside Routerpage it gets a new
// component identity on every render, so React unmounts and remounts the
// whole guarded subtree — 36 routes refetching everything on each render.
function RequireDiscoverAuth({ children }) {
  const location = useLocation();
  const { isLoggedIn } = readCustomerAuthSnapshot();
  const redirect = getSafeLoginRedirect(
    `${location.pathname}${location.search}${location.hash}`,
  );
  return isLoggedIn ? (
    children
  ) : (
    <Navigate
      to={`/login?redirect=${encodeURIComponent(redirect)}`}
      replace
      state={{ from: redirect }}
    />
  );
}

// Loading fallback for lazy-loaded routes
const RouteLoadingFallback = () => (
  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', flexDirection: 'column', gap: '1rem' }}>
    <div style={{
      width: '40px',
      height: '40px',
      border: '4px solid #e0e0e0',
      borderTop: '4px solid #333',
      borderRadius: '50%',
      animation: 'spin 1s linear infinite'
    }} />
    <div style={{ fontSize: '14px', color: '#666' }}>Loading...</div>
    <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
  </div>
);

function RouterpageContent() {
  useEffect(() => {
    fetchFlags();
  }, []);

  useEffect(() => {
    import("@flaticon/flaticon-uicons/css/all/all.css");
  }, []);

  const url =
    (
      process.env.REACT_APP_MEDIA_BASE_URL || `${API_BASE_URL}/assets/uploads/`
    ).replace(/\/+$/, "") + "/";

  const userData = JSON.parse(localStorage.getItem("userData") || "null");
  const navigate = useNavigate();
  const location = useLocation();
  const lastClassicPathRef = useRef("");

  useEffect(() => {
    const path = `${location.pathname || "/"}${location.search || ""}${location.hash || ""}`;
    if (/^\/(?:login|signup|askwitty|ask-witty)(?:\/|$)/i.test(path)) return;
    if (!path || path === "/") return;
    if (lastClassicPathRef.current === path) return;
    lastClassicPathRef.current = path;
    try { window.sessionStorage.setItem("pw_last_classic_path_v1", path); } catch {}
  }, [location.hash, location.pathname, location.search]);

  useAppRedirect();
  useUserLocation();

  const [, setCreateLeadModel] = useState(false);

  const [notif, setNotif] = useState([]);
  const [notificationLoading, setNotificationLoading] = useState(false);
  const [notificationError, setNotificationError] = useState("");

  // Pre-load all favourited club IDs into localStorage so star icons
  // show the correct filled/unfilled state on every feed card, even after
  // navigation or a fresh page load.
  useEffect(() => {
    if (!userData?.id) return;
    const formData = new FormData();
    customerApiClient
      .post("/APIs/Common/favList", formData)
      .then((res) => {
        const list = res?.data?.data;
        if (Array.isArray(list)) {
          list.forEach((club) => {
            // favList returns each club with .id = the club primary key,
            // which matches what handleAddRemoveFav stores as the key.
            const id = club?.id || club?.club_id;
            if (id) setClubFavourited(id, true);
          });
        }
      })
      .catch(() => {});
  }, [userData?.id]);

  const mergeNotificationRows = (rows = []) => {
    const seen = new Set();
    return rows.filter((item, index) => {
      const key = getNotificationKey(item, index);
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
  };

  const handleRetryNotifications = () => {
    window.dispatchEvent(new Event("partywitty-refresh-notifications"));
  };

  useEffect(() => {
    let hasForegroundListener = false;
    const fetchNotifications = async () => {
      if (!userData?.id) {
        setNotif([]);
        return;
      }
      setNotificationLoading(true);
      setNotificationError("");
      try {
        // Ask for push permission
        await requestPermission();

        try {
          const [
            ciResponse,
            nodeResponse,
            mateOutResponse,
            pendingFollowResponse,
          ] =
            await Promise.allSettled([
              customerApiClient.post(
                "/APIs/Common/pushNotifications",
                (() => { const formData = new FormData(); formData.append("category", "general"); return formData; })(),
              ),
              fetchSocialNotifications({ limit: 100 }),
              fetchMateOutNotifications({ limit: 100 }),
              userData?.id
                ? getPendingFollowRequests({}).catch(() => null)
                : Promise.resolve(null),
            ]);

          let rawCiNotifs = [];
          if (
            ciResponse.status === "fulfilled" &&
            ciResponse.value.data?.data?.length > 0
          ) {
            rawCiNotifs = normalizeNotificationList(
              ciResponse.value.data.data.map((n) => ({
                ...n,
                apiSource: "CI",
                is_read: n.status === "0" || n.status === 0 ? 1 : 0,
                notification_id: n.notification_id || n.id,
              })),
              { apiSource: "CI" },
            );
          }

          let rawNodeNotifs = [];
          if (
            nodeResponse.status === "fulfilled" &&
            nodeResponse.value.data?.data?.length > 0
          ) {
            rawNodeNotifs = normalizeNotificationList(
              nodeResponse.value.data.data.filter(
                (n) => n.notification_type !== "mate_request",
              ),
              { apiSource: "NODE" },
            );
          }

          let rawMateOutNotifs = [];
          if (
            mateOutResponse.status === "fulfilled" &&
            Array.isArray(mateOutResponse.value?.data)
          ) {
            rawMateOutNotifs = normalizeNotificationList(
              mateOutResponse.value.data.map((n) => ({
                ...n,
                apiSource: "MATEOUT",
                source: "mateout",
                product: "discover",
                notification_type: n.type || n.notification_type || "mateout",
                is_read:
                  n.is_read === true || n.is_read === 1 || n.is_read === "1"
                    ? 1
                    : 0,
              })),
              { apiSource: "MATEOUT" },
            );
          }

          let followRequestNotifs = [];
          const pendingFollowData =
            pendingFollowResponse.status === "fulfilled"
              ? pendingFollowResponse.value
              : null;
          if (pendingFollowData?.status && pendingFollowData.data?.length > 0) {
            pendingFollowData.data.forEach((req) => {
              const isMateReq =
                String(req.request_type || req.type || "").toLowerCase().includes("mate") ||
                req.is_mate_request === true ||
                req.is_mate_request === 1 ||
                req.is_mate === true ||
                req.is_mate === 1;
              const reqTitle = isMateReq ? "Mate Request" : "Follow Request";
              const reqType = isMateReq ? "mate_request" : "follow_request";
              const reqMsg = isMateReq
                ? `${req.name || "Someone"} sent you a mate request.`
                : `${req.name || "Someone"} wants to follow you.`;
              followRequestNotifs.push(
                normalizeNotificationPayload(
                  {
                    id: `follow_req_${req.request_id}`,
                    apiSource: "FOLLOW_REQUEST",
                    isFollowRequest: true,
                    request_id: req.request_id,
                    requester_id: req.user_id,
                    requester_name: req.name || "Someone",
                    requester_img: req.img || "",
                    title: reqTitle,
                    msg: reqMsg,
                    is_read: 0,
                    date: new Date().toISOString(),
                    notification_type: reqType,
                    target_profile_public_id:
                      req.public_id || req.user_public_id || "",
                  },
                  { apiSource: "FOLLOW_REQUEST" },
                ),
              );
            });
          }

          let bids = rawCiNotifs.filter((n) =>
            String(n.title || "")
              .toLowerCase()
              .includes("incoming bid"),
          );
          const others = rawCiNotifs.filter(
            (n) =>
              !String(n.title || "")
                .toLowerCase()
                .includes("incoming bid"),
          );
          let combined = [
            ...buildProfileGapNotifications(userData),
            ...others,
            ...rawNodeNotifs,
            ...rawMateOutNotifs,
            ...followRequestNotifs,
          ];

          if (bids.length > 0) {
            const unreadBids = bids.filter((b) => isNotificationUnread(b));
            bids.sort(
              (a, b) =>
                new Date(b.date || b.created_at || 0) -
                new Date(a.date || a.created_at || 0),
            );
            const venueCount = bids.length;
            combined.push({
              id: "grouped_bids_container",
              isGroupedBid: true,
              subBids: bids,
              is_read: unreadBids.length > 0 ? 0 : 1,
              title: "Incoming Bids!",
              msg: `You just received multiple bids from ${venueCount} venues!`,
              date:
                bids[0].date || bids[0].created_at || new Date().toISOString(),
            });
          }

          combined = mergeNotificationRows(combined);
          combined.sort((a, b) => {
            const dateA = new Date(a.date || a.created_at || 0);
            const dateB = new Date(b.date || b.created_at || 0);
            return dateB - dateA;
          });

          setNotif(combined.slice(0, 40));
        } catch (err) {
          console.error(err);
          setNotificationError(
            "Notifications could not be loaded. Please try again.",
          );
        }

        if (!hasForegroundListener) {
          hasForegroundListener = true;
          listenForMessages((payload) => {
            const notification = normalizeNotificationPayload(payload, {
              apiSource: "PUSH",
            });
            setNotif((prevNotif) =>
              mergeNotificationRows([notification, ...prevNotif]).slice(0, 40),
            );
          });
        }
      } catch (error) {
        console.error("Error fetching notifications:", error);
        setNotificationError(
          "Notifications could not be loaded. Please try again.",
        );
      } finally {
        setNotificationLoading(false);
      }
    };

    fetchNotifications();
    window.addEventListener("partywitty-refresh-notifications", fetchNotifications);

    let socket = null;
    const onSocialNotification = (payload) => {
      if (!payload) return;

      // Profile complete — one-time milestone toast
      if (payload?.notification_type === "profile_ready") {
        iziToast.success({
          title: "Vibe profile ready! 🎉",
          message: "You can now discover people who match your vibe.",
          position: "topRight",
          timeout: 6000,
          buttons: [
            [
              "<button>Start Discovering</button>",
              function (instance, toast) {
                instance.hide({ transitionOut: "fadeOut" }, toast);
                navigate("/discover");
              },
              true,
            ],
          ],
        });
        return;
      }

      setNotif((prev) => {
        const incomingId = payload.id != null ? String(payload.id) : "";
        if (
          incomingId &&
          prev.some(
            (n) => n.apiSource === "NODE" && String(n.id) === incomingId,
          )
        ) {
          return prev;
        }
        const mapped = normalizeNotificationPayload(payload, {
          apiSource: "NODE",
        });
        return mergeNotificationRows([mapped, ...prev]).slice(0, 40);
      });
    };
    const onRealtimeNotification = (payload) => {
      if (!payload) return;
      setNotif((prev) => {
        const incomingId = payload.id != null ? String(payload.id) : "";
        if (
          incomingId &&
          prev.some((n) => String(n.id || n.notification_id) === incomingId)
        ) {
          return prev;
        }
        const mapped = {
          ...payload,
          apiSource: payload.source === "CI" ? "CI" : "NODE",
          is_read: Number(payload.is_read || 0),
          msg: payload.message || payload.msg || payload.body || "",
          date: payload.created_at || new Date().toISOString(),
        };
        return [mapped, ...prev].slice(0, 40);
      });
    };
    const onNotificationUnreadCount = (payload) => {
      const unreadCount = Number(payload?.unread_count);
      if (!Number.isFinite(unreadCount)) return;
      if (unreadCount === 0) {
        setNotif((prev) =>
          prev.map((n) => {
            if (n.apiSource === "NODE") {
              return { ...n, is_read: 1, status: "0" };
            }
            return n;
          }),
        );
      }
    };

    try {
      if (userData?.id) {
        import("./socket.js").then(({ getSocket }) => {
          socket = getSocket();
          socket.on("social_notification", onSocialNotification);
          socket.on("notification", onRealtimeNotification);
          socket.on("notification_unread_count", onNotificationUnreadCount);
        }).catch(err => console.error(err));
      }
    } catch (err) {
      console.error(err);
    }

    return () => {
      window.removeEventListener(
        "partywitty-refresh-notifications",
        fetchNotifications,
      );
      if (socket) {
        try {
          socket.off("social_notification", onSocialNotification);
          socket.off("notification", onRealtimeNotification);
          socket.off("notification_unread_count", onNotificationUnreadCount);
        } catch (err) {
          console.error(err);
        }
      }
    };
  }, [userData?.id]);

  const handleMarkNotificationRead = async (note) => {
    if (!isNotificationUnread(note)) return;

    try {
      if (note.apiSource === "PROFILE_GAP") {
        setNotif((prev) =>
          prev.map((n) =>
            getNotificationKey(n) === getNotificationKey(note)
              ? { ...n, is_read: 1, status: "0" }
              : n,
          ),
        );
        return;
      }

      if (note.isGroupedBid) {
        for (const b of note.subBids) {
          if (isNotificationUnread(b)) {
            const formData = new FormData();
            formData.append("notification_id", b.id || b.notification_id);
            await customerApiClient
              .post("/APIs/Common/readNotification", formData)
              .catch((e) => console.error(e));
          }
        }
        setNotif((prev) =>
          prev.map((n) =>
            n.id === "grouped_bids_container"
              ? {
                  ...n,
                  is_read: 1,
                  subBids: n.subBids.map((x) => ({ ...x, is_read: 1 })),
                }
              : n,
          ),
        );
        iziToast.success({
          title: "Success",
          message: "Bids marked as read",
          position: "topRight",
          timeout: 2500,
        });
        return;
      }

      const numericNotificationId = Number(note.id || note.notification_id || 0);

      if (note.apiSource === "NODE" && numericNotificationId > 0) {
        await markSocialNotificationRead({
          notification_id: note.id,
        }).catch((e) => console.error(e));
      } else if (numericNotificationId > 0) {
        const formData = new FormData();
        formData.append("notification_id", note.id || note.notification_id);
        await customerApiClient
          .post("/APIs/Common/readNotification", formData)
          .catch((e) => console.error(e));
      }

      setNotif((prev) =>
        prev.map((n) => {
          if (n.id === "grouped_bids_container") {
            const updatedSub = n.subBids.map((b) =>
              b.id === note.id ? { ...b, is_read: 1 } : b,
            );
            return {
              ...n,
              subBids: updatedSub,
              is_read: updatedSub.some((x) => isNotificationUnread(x)) ? 0 : 1,
            };
          }
          return (n.id || n.notification_id) ===
            (note.id || note.notification_id)
            ? { ...n, is_read: 1, status: "0" }
            : n;
        }),
      );
      iziToast.success({
        title: "Success",
        message: "Notification marked as read",
        position: "topRight",
        timeout: 2500,
      });
    } catch (e) {
      console.error("Error marking read:", e);
    }
  };

  const handleMarkAllNotificationsRead = () => {
    // Optimistic update — badge and items clear immediately
    setNotif((prev) =>
      prev.map((n) => {
        if (n.isGroupedBid) {
          return {
            ...n,
            is_read: 1,
            subBids: n.subBids.map((b) => ({ ...b, is_read: 1 })),
          };
        }
        return { ...n, is_read: 1, status: "0" };
      }),
    );
    iziToast.success({
      title: "Success",
      message: "All notifications marked as read",
      position: "topRight",
      timeout: 2500,
    });

    // Fire API calls in parallel in the background
    try {
      if (userData?.id) {
        markAllSocialNotificationsRead({}).catch((e) => console.error(e));
        customerApiClient
          .post("/APIs/Common/markAllNotificationsRead", (() => { const formData = new FormData(); formData.append("category", "general"); return formData; })())
          .catch((e) => console.error(e));
      }
      notif.forEach((n) => {
        const ciItems = n.isGroupedBid
          ? (n.subBids || []).filter((b) => isNotificationUnread(b))
          : n.apiSource === "CI" && isNotificationUnread(n)
            ? [n]
            : [];
        ciItems.forEach((note) => {
          const formData = new FormData();
          formData.append("notification_id", note.id || note.notification_id);
          customerApiClient
            .post("/APIs/Common/readNotification", formData)
            .catch((e) => console.error(e));
        });
      });
    } catch (e) {
      console.error("Error marking all read:", e);
    }
  };

  const handleFollowRequestHandled = (notifId) => {
    setNotif((prev) => prev.filter((n) => n.id !== notifId));
    if (userData?.id) {
      getPendingFollowRequests({})
        .then((res) => {
          const incoming =
            res?.status && Array.isArray(res.data) ? res.data : [];
          const rebuilt = incoming.map((req) => {
              const isMateReq =
                String(req.request_type || req.type || "").toLowerCase().includes("mate") ||
                req.is_mate_request === true ||
                req.is_mate_request === 1 ||
                req.is_mate === true ||
                req.is_mate === 1;
              const reqTitle = isMateReq ? "Mate Request" : "Follow Request";
              const reqType = isMateReq ? "mate_request" : "follow_request";
              const reqMsg = isMateReq
                ? `${req.name || "Someone"} sent you a mate request.`
                : `${req.name || "Someone"} wants to follow you.`;
              return normalizeNotificationPayload(
                {
                  id: `follow_req_${req.request_id}`,
                  apiSource: "FOLLOW_REQUEST",
                  isFollowRequest: true,
                  request_id: req.request_id,
                  requester_id: req.user_id,
                  requester_name: req.name || "Someone",
                  requester_img: req.img || "",
                  title: reqTitle,
                  msg: reqMsg,
                  is_read: 0,
                  date: new Date().toISOString(),
                  notification_type: reqType,
                  target_profile_public_id:
                    req.public_id || req.user_public_id || "",
                },
                { apiSource: "FOLLOW_REQUEST" },
              );
            });
          setNotif((prev) => [
            ...prev.filter((n) => n.apiSource !== "FOLLOW_REQUEST"),
            ...rebuilt,
          ]);
        })
        .catch(() => {});
    }
  };

  return (
    <>
      <MetaHead />
      <ScrollToTop />
      <PixelManager />
      <SessionExpiredLoginPrompt />
      <PopupQueueManager />
      <DeepLinkHandler />

      {/* {!locationAllowed && hasCheckedPermission && (
        <LocationPopUpModal
          onAllow={requestLocation}
          errorMessage={errorMessage}
        />
      )} */}

      {/* {showModal && (
        <AppRedirectBar
          onOpenApp={openApp}
          onContinue={continueInBrowser}
        />
      )} */}

      <GoToTopButton />

      <div className="router-page">
        <div className="home-page-design">
          {/* <NavbarConditional /> */}
          {/* <AdPromotionalBanner /> */}
        </div>
        <div className="app-shell">
          <NavbarConditional
            userData={userData}
            url={url}
            logo2={logo2}
            notif={notif}
            setCreateLeadModel={setCreateLeadModel}
            onMarkNotificationRead={handleMarkNotificationRead}
            onMarkAllNotificationsRead={handleMarkAllNotificationsRead}
            onFollowRequestHandled={handleFollowRequestHandled}
            notificationLoading={notificationLoading}
            notificationError={notificationError}
            onRetryNotifications={handleRetryNotifications}
          />
          {/* <HomeHeaderSidebar
           
          /> */}

          <main className="app-content">
            {/* <BreadcrumbsWrapper routeslist={routeslist} labelMap={labelMap} /> */}
            <Suspense fallback={<RouteLoadingFallback />}>
            <Routes className="">
              <Route
                path="/app/continue"
                element={<AppContinuationLanding />}></Route>

              {/* <Route
            path="/:city/:area/:clubname"
            element={<Clubaboutuspagesearch />}
          ></Route> */}

              {/* azam */}
              <Route
                path="/login"
                element={<LoginRoute userData={userData} />}
              />
              <Route
                path="/signup"
                element={<LoginRoute userData={userData} intentReason="signup_route" />}
              />

              <Route
                path="/register/complete"
                element={<DiscoverReadyPage />}
              />

              <Route
                path="/discover-profile"
                element={
                  <RequireDiscoverAuth>
                    <DiscoverProfile />
                  </RequireDiscoverAuth>
                }></Route>

              <Route
                path="/discover-profile-detail/:profileId"
                element={
                  <RequireDiscoverAuth>
                    <DiscoverProfileDetail />
                  </RequireDiscoverAuth>
                }></Route>

              <Route
                path="/discover-verification"
                element={
                  <RequireDiscoverAuth>
                    <ProfileVerificationFlow />
                  </RequireDiscoverAuth>
                }></Route>

              <Route path="/askwitty" element={<AskWittyPage />} />
              <Route path="/ask-witty" element={<LegacyAskWittyRedirect />} />
              <Route
                path="/discover-room/:roomId"
                element={<RequireDiscoverAuth><DiscoverPrivateRoomPage /></RequireDiscoverAuth>}
              />
              <Route
                path="/askwitty/testing"
                element={<AskWittyPage testingRoute />}
              />
              <Route
                path="/ask-witty/testing"
                element={<LegacyAskWittyRedirect />}
              />

              {/* Dev-only coverage dashboard — not registered in prod builds
                  (CoverageTracker is null outside development). */}
              {CoverageTracker && (
                <Route path="/dev/coverage" element={<CoverageTracker />} />
              )}

              {/* Dev-only platform rules registry — same prod exclusion. */}
              {PlatformRulesViewer && (
                <Route path="/dev/rules" element={<PlatformRulesViewer />} />
              )}

              {(process.env.NODE_ENV !== "production" ||
                process.env.REACT_APP_ASKWITTY_ARSENAL_ENABLED === "true") &&
                VpnArsenalRoute &&
                WittyCardArsenal && (
                  <Route
                    path="/arsenal"
                    element={
                      <React.Suspense fallback={<div role="status">Loading Ask Witty Test Lab…</div>}>
                        <VpnArsenalRoute>
                          <WittyCardArsenal />
                        </VpnArsenalRoute>
                      </React.Suspense>
                    }
                  />
                )}

              {(process.env.NODE_ENV !== "production" ||
                process.env.REACT_APP_ASKWITTY_ARSENAL_ENABLED === "true") &&
                VpnArsenalRoute &&
                WittyCardArsenal && (
                  <Route
                    path="/arsenal/:flowId"
                    element={
                      <React.Suspense fallback={<div role="status">Loading Ask Witty Test Lab…</div>}>
                        <VpnArsenalRoute>
                          <WittyCardArsenal />
                        </VpnArsenalRoute>
                      </React.Suspense>
                    }
                  />
                )}

              <Route
                path="/events-listing"
                element={
                  <RequireDiscoverAuth>
                    <EventsListing />
                  </RequireDiscoverAuth>
                }></Route>
              <Route
                path="/invite-event-picker"
                element={
                  <RequireDiscoverAuth>
                    <InviteEventPicker />
                  </RequireDiscoverAuth>
                }></Route>
              <Route
                path="/drink-listing"
                element={
                  <RequireDiscoverAuth>
                    <DrinkLishting />
                  </RequireDiscoverAuth>
                }></Route>
              {/* [P0] orphan typo alias -> canonical /drink-listing (redirect-only, route kept) */}
              <Route
                path="/drink-lishting"
                element={<Navigate to="/drink-listing" replace />}
              ></Route>
              <Route
                path="/discover-order-summery"
                element={
                  <RequireDiscoverAuth>
                    <DiscoverOrderSummery />
                  </RequireDiscoverAuth>
                }></Route>
              <Route
                path="/discover-swipe-history"
                element={
                  <RequireDiscoverAuth>
                    <DiscoverSwipeHistory />
                  </RequireDiscoverAuth>
                }></Route>

              <Route
                path="/interest-record"
                element={<UserInterestRecord />}></Route>

              <Route
                path="/discover"
                element={
                  <Discover
                    notifications={notif}
                    onMarkNotificationRead={handleMarkNotificationRead}
                    onMarkAllNotificationsRead={handleMarkAllNotificationsRead}
                    onFollowRequestHandled={handleFollowRequestHandled}
                    notificationLoading={notificationLoading}
                    notificationError={notificationError}
                    onRetryNotifications={handleRetryNotifications}
                  />
                }></Route>

              <Route path="/d/:code" element={<ReferralLanding />}></Route>

              <Route
                path="/event-invitation"
                element={<EventInvitation />}></Route>

              <Route
                path="/go-tonight"
                element={
                  <RequireDiscoverAuth>
                    <GoTonight />
                  </RequireDiscoverAuth>
                }></Route>

              <Route path="/founding" element={<FoundingPage />}></Route>
              <Route path="/score" element={<ScorePage />}></Route>
              <Route path="/party-ready-score" element={<ScorePage />}></Route>
              <Route path="/badges" element={<BadgeShowcase />}></Route>
              <Route path="/leaderboard" element={<WeeklyLeaderboard />}></Route>
              <Route path="/referrals" element={<ReferralDashboard />}></Route>
              <Route path="/ref/:code" element={<Navigate to="/" replace />}></Route>

              {/* Deliberately NOT wrapped in RequireDiscoverAuth. These routes are
                  reachable from Ask Witty, and a redirect to /login would throw the
                  viewer out of the AI experience into classic view — the one thing
                  that must never happen on its own. Signed-out handling belongs in
                  the screens themselves, as an in-place prompt. */}
              <Route path="/wittyprezo/verify" element={<VerificationSuccess />}></Route>
              <Route path="/wittyprezo/loading" element={<ScoreLoading />}></Route>
              <Route path="/wittyprezo/score" element={<WittyPrezoScoreCard />}></Route>
              <Route path="/wittyprezo/feed-preview" element={<FeedPostPreview />}></Route>
              <Route path="/wittyprezo/story" element={<StoryExport />}></Route>
              <Route path="/wittyprezo/breakdown" element={<WittyPrezoBreakdown />}></Route>
              <Route path="/event-chat/:bookingId/intro" element={<WittyCueIntro />}></Route>
              <Route path="/event-chat/:bookingId" element={<EventChatThread />}></Route>

              <Route path="/policy" element={<PolicyListPage />}></Route>
              <Route path="/policy/:slug" element={<PolicyDetailPage />}></Route>

              <Route
                exact
                path="/"
                element={<FeedPage />}
              ></Route>
              <Route path="/feed" element={<FeedPage />}></Route>
              <Route path="/feed-uno" element={<FeedPageUno />}></Route>
              <Route path="/carnival-card" element={<FeedDemo />}></Route>
              <Route path="/carnivals" element={<CarnivalsListing />}></Route>
              <Route
                path="/carnivals/:param1?/:param2?"
                element={<CarnivalsListing />}
              />
              <Route
                path="/carnival/:carnivalname"
                element={<CarnivalDetailPage />}></Route>

              <Route
                path="/Artist-Onboarding"
                element={<ArtistOnboardingForm />}></Route>

              <Route
                path="/artist-onboarding/thank-you"
                element={<ArtistOnboardingFormThankYou />}></Route>

              <Route
                path="/carnival-book/:club_id/:id"
                element={<CarnivalBooking />}></Route>
              <Route
                path="/carnival/thank-you"
                element={<CarnivalThankYou />}></Route>

              {/* <Route exact path="/venues-restaurant/:clubname/:city/:area" element={<VenueClubDetailsPage />}></Route> */}

              <Route exact path={"/my-plan"} element={<GroupBooking />}></Route>
              <Route
                exact
                path={"/package-lead-form"}
                element={<GroupBooking />}></Route>
              <Route
                exact
                path={"/table-book-form"}
                element={<TableBookingForm />}></Route>
              <Route
                exact
                path={"/package-lead-submitted"}
                element={<PackageLeadSubmitted />}></Route>
              <Route
                exact
                path={"/table-booking-submitted"}
                element={<TableLeadSubmitted />}></Route>

              {/* azam */}

              {/* No-price SEO detail pages (shared VenuePackageDetail component, D-074).
                  Kept off the existing /venue/:clubInfo and /party-package/:.../:.
                  paths intentionally — those still carry the classic pages' live
                  table-booking/bid flows; a distinct path avoids any regression
                  risk there (see PR notes). */}
              <Route
                exact
                path="/venue-info/:clubInfo"
                element={<VenueDetailSeoPage />}></Route>
              <Route
                exact
                path="/package-info/:clubSlug/:packageSlug"
                element={<PackageDetailSeoPage />}></Route>
              <Route
                exact
                path="/venue/:clubInfo"
                element={<VenueClubDetailsPage />}></Route>
              <Route
                exact
                path="/venue-bid-detail/:clubInfo/:id"
                element={<VenueClubDetailsPage />}></Route>
              <Route
                exact
                path="/venue/:clubInfo/:tab"
                element={<VenueClubDetailsPage />}></Route>
              <Route
                exact
                path="/venue/:clubInfo/:tab"
                element={<VenueClubDetailsPage />}></Route>
              <Route
                exact
                path="/venue/:clubInfo/review/:clubID"
                element={<VenueClubReview />}></Route>
              <Route
                exact
                path="/partywitty-pay"
                element={<PartywittyPay />}></Route>
              <Route
                exact
                path="/partywitty-pay/checkout"
                element={<PartywittyCheckout />}></Route>
              <Route
                exact
                path="/partywitty-pay/thank-you"
                element={<PartywittyPayThankyou />}></Route>
              <Route exact path="/v/:slug" element={<VenueMenuPage />}></Route>
              <Route exact path="/qr/:code" element={<VenueMenuPage />}></Route>

              {/* azam */}
              <Route path="/venues" element={<VenuesListingPage />}></Route>
              <Route path="/chat" element={<Chat />}></Route>
              <Route
                path="/venues/:slug"
                element={<VenuesListingPage />}></Route>
              <Route
                path="/venues/:category/:city"
                element={<VenuesListingPage />}></Route>
              <Route path="/venues/*" element={<VenuesListingPage />}></Route>

              {/* <----************************** Test Start **********************-----------> */}
              <Route exact path="/loader" element={<TableBidCard />}></Route>
              <Route
                exact
                path="/user-profile"
                element={
                  <RequireDiscoverAuth>
                    <ProfileV2 />
                  </RequireDiscoverAuth>
                }></Route>
              <Route
                exact
                path="/profile/self"
                element={
                  <RequireDiscoverAuth>
                    <ProfileSelfViewPage />
                  </RequireDiscoverAuth>
                }></Route>
              <Route
                exact
                path="/profile/complete"
                element={
                  <RequireDiscoverAuth>
                    <ProfileCompletePage />
                  </RequireDiscoverAuth>
                }></Route>
              <Route
                exact
                path="/mate-requests"
                element={
                  <RequireDiscoverAuth>
                    <MateRequestsPage />
                  </RequireDiscoverAuth>
                }></Route>
              <Route
                exact
                path="/profile"
                element={
                  <RequireDiscoverAuth>
                    <ProfileV2 />
                  </RequireDiscoverAuth>
                }></Route>
              <Route
                path="/profile/:profileUsername"
                element={<ProfileV2 />}></Route>
              <Route
                exact
                path="/profile/edit"
                element={
                  <RequireDiscoverAuth>
                    <ProfilePersonalDetailsPage />
                  </RequireDiscoverAuth>
                }></Route>
              <Route exact path="/career" element={<CareersPage />}></Route>
              <Route path="/career/:slug" element={<CareersPage />}></Route>
              <Route
                exact
                path="/profile/artist"
                element={
                  <RequireDiscoverAuth>
                    <ProfileArtistPage />
                  </RequireDiscoverAuth>
                }></Route>
              <Route
                exact
                path="/my-profile"
                element={
                  <RequireDiscoverAuth>
                    <ProfileV2 />
                  </RequireDiscoverAuth>
                }></Route>
              <Route exact path="/new-my-plan" element={<NewMyPlan />}></Route>

              <Route
                path="/dashboard"
                element={
                  <RoleProtectedRoute
                    allowedRoles={[
                      "customer",
                      "artist",
                      "sponsor",
                      "influencer",
                      "crp-admin",
                      "crp-employee",
                      "venue-*",
                      "vendor-*",
                    ]}>
                    <DashboardRouter />
                  </RoleProtectedRoute>
                }
              />

              {/* <Route exact path="/dashboard" element={<Dashboard />}></Route> */}
              <Route exact path="/wallet" element={<WalletPage />}></Route>
              <Route
                exact
                path="/transaction"
                element={<Transaction />}></Route>
              <Route
                exact
                path="/carrots"
                element={<CarrotsTransaction />}></Route>
              <Route
                exact
                path="/tulips"
                element={<TulipsTransaction />}></Route>
              <Route
                exact
                path="/voucher"
                element={<VoucherTransaction />}></Route>
              <Route
                exact
                path="/messages"
                element={<ChatSectionUnique />}></Route>

              {/* <----************************** Test end **********************-----------> */}

              {/* <Route path="/carnival/:type" element={<Carnival />}></Route> */}
              {/* <Route path="/carnival/:type/:club_id?" element={<ClubCarnival />}></Route> */}
              <Route
                path="/payCarnivalPass/:order_id"
                element={<CarnivalPassPayment />}></Route>
              <Route
                path="/CarnivalPassPaymentStatus/:order_id"
                element={<CarnivalPassPaymentStatus />}></Route>
              <Route
                path="/refundCarnivalPass/:order_id"
                element={<CarnivalPassRefund />}></Route>
              <Route
                path="/CarnivalPassRefundStatus/:order_id"
                element={<CarnivalPassRefundStatus />}></Route>
              {/* <Route exact path="/:city/:area/:club/carnival/:id" element={<CarnivalPassDetails />}></Route>
              <Route exact path="/:city/:area/:club/carnival" element={<CarnivalPassDetails />}></Route> */}
              {/* <Route path="/event-book/:club_id/:id" element={<EventBookNow />}></Route> */}

              {/* <-------------------------------------------------------------------------> */}

              <Route path="/events" element={<EvenetListingPage />} />
              <Route path="/events/today" element={<EvenetListingPage />} />
              <Route
                path="/events/today/:page"
                element={<EvenetListingPage />}
              />
              <Route path="/events/tomorrow" element={<EvenetListingPage />} />
              <Route
                path="/events/tomorrow/:page"
                element={<EvenetListingPage />}
              />
              <Route path="/events/carnival" element={<EvenetListingPage />} />
              <Route
                path="/events/carnival/:page"
                element={<EvenetListingPage />}
              />
              <Route
                path="/events/today/carnival"
                element={<EvenetListingPage />}
              />
              <Route
                path="/events/today/carnival/:page"
                element={<EvenetListingPage />}
              />
              <Route
                path="/events/tomorrow/carnival"
                element={<EvenetListingPage />}
              />
              <Route
                path="/events/tomorrow/carnival/:page"
                element={<EvenetListingPage />}
              />
              <Route
                path="/events/page/:page"
                element={<EvenetListingPage />}
              />
              <Route path="/events/:city" element={<EvenetListingPage />} />
              <Route
                path="/events/:city/today"
                element={<EvenetListingPage />}
              />
              <Route
                path="/events/:city/today/:page"
                element={<EvenetListingPage />}
              />
              <Route
                path="/events/:city/tomorrow"
                element={<EvenetListingPage />}
              />
              <Route
                path="/events/:city/tomorrow/:page"
                element={<EvenetListingPage />}
              />
              <Route
                path="/events/:city/carnival"
                element={<EvenetListingPage />}
              />
              <Route
                path="/events/:city/carnival/:page"
                element={<EvenetListingPage />}
              />
              <Route
                path="/events/:city/today/carnival"
                element={<EvenetListingPage />}
              />
              <Route
                path="/events/:city/today/carnival/:page"
                element={<EvenetListingPage />}
              />
              <Route
                path="/events/:city/tomorrow/carnival"
                element={<EvenetListingPage />}
              />
              <Route
                path="/events/:city/tomorrow/carnival/:page"
                element={<EvenetListingPage />}
              />
              <Route
                path="/events/:city/page/:page"
                element={<EvenetListingPage />}
              />
              <Route path="/events/*" element={<EvenetListingPage />} />

              <Route
                path="/event/:clubdetail/:eventname"
                element={<EventDetailPage />}
              />
              <Route
                path="/event/:clubdetail/:eventname/:id"
                element={<EventDetailPage />}
              />
              <Route path="/m/:code" element={<VenueMenuPage />}></Route>
              {/* <Route
                path="/carnival/:carnivalname"
                element={<EventDetailPage />}
              /> */}

              {/* azam */}
              <Route
                path="/event-book/:club_id/:id"
                element={<EventBooking />}></Route>

              <Route
                path="/carnival-book/:club_id/:id"
                element={<EventBooking />}></Route>

              <Route
                path="/event/thank-you"
                element={<EventThankYouPage />}></Route>

              <Route
                path="/payment-now"
                element={<MultiplebookingPay />}></Route>

              {/* <-------------------------------------------------------------------------> */}

              {/* <-------------------------------------------------------------------------> */}

              <Route path="/bid-list" element={<BidListingPageNew />}></Route>
              <Route
                path="/catering-bid-list"
                element={<CateringBidListing />}></Route>
              <Route
                path="/catering-bid-list/:id"
                element={<CateringBidListing />}></Route>

              <Route
                path="/bid-list/:id"
                element={<BidListingPageNew />}></Route>

              <Route
                path="/table-booking/:id"
                element={<OrderSummary />}></Route>
              <Route
                path="/package-booking/:id"
                element={<OrderSummary />}></Route>
              <Route path="/checkout/:orderId" element={<Checkout />}></Route>

              {/* azam */}
              <Route
                path="/payment-done/:id"
                element={<PaymentDonePage />}></Route>
              <Route
                path="/payment-confirm/:id"
                element={<PaymentConfirmPage />}></Route>
              <Route path="/add-menu/:id" element={<AddMenuPage />}></Route>
              <Route path="/add-guest/:id" element={<AddGuestList />}></Route>

              {/* <-------------------------------------------------------------------------> */}

              <Route path="/success" element={<Successpage />}></Route>
              <Route path="/our-artist" element={<Successpage />}></Route>
              <Route
                path="/my-booking-history"
                element={<MyBookingHistory />}></Route>
              <Route
                path="/discover-meet-review/:orderId"
                element={<DiscoverMeetReview />}></Route>
              <Route
                path="/discover-guest-review/:orderId"
                element={<GuestMeetReview />}></Route>

              {/* <-------------------------------------------------------------------------> */}

              {/* azam */}
              <Route path="/my-bookings" element={<MyBookingPage />}></Route>

              <Route path="/refund-request" element={<RefundPage />}></Route>
              <Route
                path="/my-bookings/:tabName"
                element={<MyBookingPage />}></Route>
              <Route
                path="/my-bookings-details/:id"
                element={<MyBookingDetail />}></Route>

              {/* Static preview of the 4 MateOut invite/drink screens */}
              <Route
                path="/demo/invite-flow"
                element={<InviteFlowDemo />}></Route>

              <Route
                path="/gig-execution/:id"
                element={<GigExecutionPage />}></Route>

              <Route
                path="/my-bookings/review/:clubID"
                element={<ClubReviewPage />}></Route>
              <Route
                path="/my-bookings/review/thank-you"
                element={<ClubReviewThankYou />}></Route>

              {/* <-------------------------------------------------------------------------> */}

              {/* azam */}
              <Route
                exact
                path="/package/:city/:area/:club/:packageName"
                element={<PartyPackageDetailPage />}></Route>

              <Route exact path={"/v2"} element={<HomeV2 />}></Route>

              <Route path="/thank-you" element={<ThankewPage />}></Route>
              <Route path="/success" element={<Successpage />}></Route>

              {/* azam */}
              <Route path="/favourite-club" element={<MyFavClub />}></Route>

              <Route
                path="/subscription-price"
                element={<PartnerWithUs />}></Route>
              <Route path="/my--booking" element={<MyBooking />}></Route>
              <Route path="/my--profile" element={<MyProfile />}></Route>
              <Route
                path="/my--Notification"
                element={<MyNotification />}></Route>
              <Route path="/my-Favorite--ham" element={<MyFavorite />}></Route>

              {/* <Route exact path="/:city/:area/:club/:packageName" element={<PackageAboutUs />}></Route> */}
              {/* <Route path="/favourite-club" element={<Favclub />}></Route> */}
              {/* <Route path="/partner-with-us" element={<PackagePrice />}></Route> */}
              {/* <Route path="/events" element={<EventViewAll />}></Route> */}
              {/* <Route path="/party-packages/:id" element={<PopularPackageView />}></Route> */}
              {/* <Route exact path={"/party-packages"} element={<GroupBookingViewall />}></Route> */}
              {/* <Route path="/bid-list/:id" element={<BidListPage />}></Route> */}
              {/* <-------------------------------------------------------------------------> */}

              <Route
                path="/party-packages"
                element={<PartyPackageListingPage />}
              />
              <Route path="/compare-party-packages" element={<Compare />} />
              <Route path="/artist/artist-detail" element={<ProfileV2 />} />
              <Route path="crp/profile" element={<CRPProfile />} />
              <Route
                path="/party-packages-new"
                element={<PackageListingPage />}
              />
              {/* azam */}
              <Route
                path="/party-packages/:slug"
                element={<PartyPackageListingPage />}></Route>
              <Route
                path="/party-packages/:title/:city"
                element={<PartyPackageListingPage />}></Route>
              <Route
                path="/party-packages/*"
                element={<PartyPackageListingPage />}></Route>

              {/* azam */}
              <Route
                exact
                path="/party-package/:packagedetail/:title"
                element={<PartyPackageDetailPage />}></Route>
              <Route
                exact
                path="/party-package/:packagedetail/:title/:tab"
                element={<PartyPackageDetailPage />}></Route>
              <Route
                exact
                path="/bid-detail/:packagedetail/:title/:id/:club_id?"
                element={<PartyPackageDetailPage />}></Route>
              <Route
                exact
                path="/catering-detail/:packagedetail/:title/:id/:tab?"
                element={<CateringBidDetailPage />}></Route>

              {/* <-------------------------------------------------------------------------> */}

              {/* <-------------------------------------------------------------------------> */}

              <Route
                path="/caterings"
                element={<CateringListingPage />}></Route>
              <Route
                path="/catering/:packagedetail/:title"
                element={<CateringDetailPage />}></Route>
              <Route
                path="/catering/:packagedetail/:title/:id/:tab?"
                element={<CateringDetailPage />}></Route>

              {/* <-------------------------------------------------------------------------> */}

              <Route
                path="/FavorateHangoutThumbnail"
                element={<FavorateHangoutThumbnail />}></Route>
              <Route
                path="/TableBookingViewall"
                element={<TableBookingViewall />}></Route>
              <Route
                path="/GroupBookingViewall"
                element={<GroupBookingViewall />}></Route>
              {/* <Route path="/party-packages" element={<PopularPackageViewall />}></Route> */}

              {/* <Route path="/venues" element={<BookATableViewAll />}></Route> */}

              {/* <Route path="/venues/:cityname" element={<FavorateHangoutViewall />}></Route> */}

              {/* <Route path="/newly-added-club-delhi-ncr-view-all" element={<NewlyAddedClubViewAll />}></Route> */}

              <Route path="/Payment-Failed" element={<HoliFailed />}></Route>
              <Route path="/ClubDetail/:id" element={<ClubDetails />}></Route>
              <Route path="/result" element={<SearchResult />}></Route>
              {/* <Route path="/:city/:area/club/:clubname" element={<ClubFullDetails />}></Route> */}
              {/* <Route path="/:city/:area/:club/event/:title" element={<EventAboutUS />} /> */}

              {/* azam */}
              {/* <Route path="/:city/:area/:club/event/:title" element={<EventAboutUS />} /> */}

              {/* <Route path="/:city/:area/:club/recommendevent/:title" element={<EventAboutUS />} /> */}

              <Route exact path="/artist-page" element={<OurArtist />}></Route>
              <Route exact path="/club-about-us" element={<Clubpage />}></Route>
              <Route path="/refund-policy" element={<RefundPolicy />}></Route>
              <Route
                path="/artist-agreement"
                element={<ArtistAgreement />}></Route>
              <Route path="/club-agreement" element={<ClubAgreement />}></Route>

              <Route
                path="/partner-as-an-artist"
                element={<Asanartist />}></Route>
              <Route
                path="/partner-with-us/as-caterer"
                element={<PartnerAsAnCaterer />}></Route>

              <Route path="/partner" element={<VenueLandingPage />}></Route>
              <Route
                path="/partner-with-us/as-artist"
                element={<PartnerAsAnArtist />}></Route>

              <Route path="/components" element={<Components />}></Route>
              <Route path="/components/Buttons" element={<Buttons />}></Route>
              <Route path="/components/icons" element={<Icons />}></Route>
              <Route path="/components/fonts" element={<Fonts />}></Route>
              <Route path="/components/cards" element={<Cards />}></Route>
              <Route
                path="/partner-as-an-caterer/onboarding"
                element={<PAACOnbordingForm />}></Route>

              <Route
                path="/partner-with-us-as-event-organizer"
                element={<EventOrgOnboardingPage />}></Route>
              <Route
                path="/partner-with-us-as-event-organizer/onboarding"
                element={<EventOrgOnboardingForm />}></Route>

              <Route path="/about-us" element={<AboutusPageNew />}></Route>
              <Route
                path="/book-as-a-artist"
                element={<BookanArtist />}></Route>
              <Route path="/as-club" element={<PartnerwithUs />}></Route>
              <Route
                path="/custom-package-services"
                element={<Services />}></Route>
              <Route path="/contact-us" element={<ContactUs />}></Route>
              <Route
                path="/contact-us/thank-you"
                element={<ContactUsThankYou />}></Route>
              <Route
                path="/booknow--table--cart/:id"
                element={<BookNowBookATable />}></Route>
              <Route path="/nextPage" element={<Summerypage />}></Route>

              <Route
                path="/thank--you--page"
                element={<NewThankewPage />}></Route>

              <Route path="/cracker" element={<Fireworks />}></Route>
              {/* azam */}
              <Route
                path="/corporate-recreation-program/inquiry-form"
                element={<Home />}></Route>
              {/* <Route
                path="/corporate-recreation-program"
                element={<CRPLandingPage />}></Route> */}

              <Route
                path="/corporate-recreation-program"
                element={<CrownMembershipForm />}></Route>
              <Route
                path="/happening-party-page"
                element={<Happeningparty />}></Route>
              <Route
                path="/happening-view-page"
                element={<HappeningViewButton />}></Route>
              <Route
                path="/music-view-page"
                element={<MusicViewButton />}></Route>
              <Route path="/comming-soon" element={<CommingSoon />}></Route>
              <Route
                path="/partner-with-us/as-venue"
                element={<RegistrationLoginForm />}></Route>
              <Route
                path="/partner-with-us/as-venue/thank-you"
                element={<PartnerEnquiryThankYou />}></Route>

              <Route
                path="/partner-with-us/as-event-organizer"
                element={<EventOrganizer />}></Route>
              <Route
                path="/partner-with-us/event-organizer/thank-you"
                element={<PartnerEnquiryThankYou />}></Route>
              <Route
                path="/partner-with-us/as-influencer"
                element={<Influencer />}></Route>
              <Route
                path="/partner-with-us/Influencer/thank-you"
                element={<PartnerEnquiryThankYou />}></Route>
              <Route
                path="/partner-with-us/as-artist/thank-you"
                element={<PartnerEnquiryThankYou />}></Route>
              <Route
                path="/partner-as-an-caterer/thank-you"
                element={<PartnerEnquiryThankYou />}></Route>
              <Route
                path="/business-registration-submitted"
                element={<RegistrationLoginFormSubmitted />}></Route>

              <Route path="/privacy-policy" element={<Privacypolicy />}></Route>
              <Route
                path="/term-conditions-policy"
                element={<Termscondition />}></Route>
              <Route
                path="/cancellation-policy"
                element={<Cancellationpolicy />}></Route>
              <Route path="/payment" element={<Paymentpage />}></Route>

              <Route path="/blogs" element={<Blog />}></Route>
              <Route path="/artists" element={<ArtistCard />}></Route>
              {/* azam */}
              <Route
                path="/artists-test"
                element={<ArtistsListingPage />}></Route>
              <Route
                path="/artist-listing"
                element={<ArtistsListingPage />}></Route>
              <Route
                path="/artist/:artistId/get-quote"
                element={<ArtistQuoteFormPage />}></Route>
              <Route
                path="/artist/opportunity/:token"
                element={<ArtistOpportunityPage />}></Route>
              <Route
                path="/artist/enquiry/:leadId/quotes"
                element={<ArtistQuotesPage />}></Route>
              <Route
                path="/artist/booking/:orderId/checkout"
                element={<ArtistBookingCheckoutPage />}></Route>
              <Route
                path="/artist/booking/thank-you"
                element={<ArtistBookingThankYouPage />}></Route>
              <Route
                path="/artist/:artistId"
                element={<ArtistHireDetailPage />}></Route>
              <Route path="/blogs/:title" element={<BlogDetails />}></Route>
              <Route path="/club-detail" element={<ClubDetail />}></Route>
              <Route path="/:profileUsername" element={<ProfileV2 />}></Route>
              <Route path="*" element={<PageNotFound />}></Route>
            </Routes>
            </Suspense>
          </main>
        </div>
      </div>
      <div className="footer-section">{/* <FooterConditional /> */}</div>
      {!location.pathname.startsWith("/artist/opportunity/") ? <FloatingHelpWidget /> : null}
      {!location.pathname.startsWith("/artist/opportunity/") ? <AskWittySignoutFeedback /> : null}
    </>
  );
}

export default function Routerpage() {
  return (
    <Router>
      <RouterpageContent />
    </Router>
  );
}
